import { IconButton, Modal } from "@carbon6/c6-frontend-design";
import { useId, type ReactNode } from "react";
import { HatModalHeader } from "@/components/modal";
import { EvalStartSummary } from "./EvalStartSummary";
import type { EvalParamSpec, EvalParamValues } from "./evalParamSpecs";
import type { EvaluationTargetPolicy } from "./evaluationTargetPolicy";
import styles from "./EvalStartConfirmationModal.module.css";

// EvaluationParamsModal 위에 겹쳐 뜨는(`level="top"`) 확인 창. 본문은 공유 `EvalStartSummary` 에
// 대상 policy 를 추가한 것이다. 추가 조회는 없다.

export type EvalStartConfirmationModalProps = {
  open: boolean;
  policies: readonly EvaluationTargetPolicy[];
  selectedTag: string;
  imageUri: string | null;
  specs: readonly EvalParamSpec[];
  values: EvalParamValues;
  // seed 계획의 policy 당 평가 수. seed 입력이 유효하지 않으면 null 이다.
  seedCount: number | null;
  // 부모 모달이 소유한 상대 시각 기준. 그래서 두 다이얼로그가 같은 시계를 읽는다.
  nowMs: number;
  // 요청이 진행 중이면 닫기를 잠그고 진행 라벨을 표시한다.
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function EvalStartConfirmationModal({
  open,
  policies,
  selectedTag,
  imageUri,
  specs,
  values,
  seedCount,
  nowMs,
  busy,
  onConfirm,
  onCancel,
}: EvalStartConfirmationModalProps): ReactNode {
  const titleId = useId();

  return (
    <Modal
      open={open}
      onClose={onCancel}
      size="lg"
      level="top"
      maxHeight="90vh"
      closeOnBackdropClick={!busy}
      closeOnEscape={!busy}
      aria-labelledby={titleId}
    >
      <HatModalHeader
        title="아래 설정으로 Evaluation을 실행합니다."
        titleId={titleId}
        close={{ disabled: busy }}
      />
      {/* 헤더와 푸터 사이 스크롤은 Modal.Body 가 소유하고, 안쪽 div 는 padding 을 소유한다.
          스크롤바를 숨겨 표와 푸터 버튼의 끝선을 맞춘다. */}
      <Modal.Body padding={false} className={styles.hiddenScrollbar}>
        <div className={styles.body}>
          <EvalStartSummary
            selectedTag={selectedTag}
            imageUri={imageUri}
            specs={specs}
            values={values}
            seedCount={seedCount}
            policies={{ items: policies, nowMs }}
          />
        </div>
      </Modal.Body>
      <div className={styles.footer}>
        <IconButton text="취소" type="button" variant="ghost" disabled={busy} onClick={onCancel} />
        <IconButton
          text={busy ? "Evaluation 시작 중…" : "Evaluation 시작"}
          type="button"
          variant="solid"
          tone="primary"
          disabled={busy}
          onClick={onConfirm}
        />
      </div>
    </Modal>
  );
}
